import posterUrl from "~/assets/images/welcome-tour-poster.webp";
import { useTeam } from "~/contexts/TeamProvider";
import { useMarkOnboardingStep } from "~/hooks/useMarkOnboardingStep";

import { WELCOME_VIDEO_URL } from "../consts";
import LazyVideo from "./LazyVideo";

/**
 * The welcome tour. Playing or unmuting it marks the "watch the tour" step
 * of the launch checklist; once it's marked, the autoplay has done its job.
 */
const WelcomeVideo = () => {
  const markOnboardingStep = useMarkOnboardingStep();
  const { team } = useTeam();

  return (
    <LazyVideo
      src={WELCOME_VIDEO_URL}
      poster={posterUrl}
      caption="Start here: a 2-minute tour from our CEO Kyle"
      playLabel="Play the welcome tour"
      autoplay={!team?.onboarding_tour_watched_at}
      onWatch={() => markOnboardingStep("onboarding_tour_watched_at")}
    />
  );
};

export default WelcomeVideo;
